export default __webpack_public_path__ + "static/media/info-panel-open.20340da0.svg";